export default {"gitHash":"d09a42baf003440e0601850a268954823150d5a3","gitHashShort":"d09a42b","time":1680175965459,"platform":"linux","arch":"x64"};